import React, { useState } from "react";
import { StepsWrapper } from "./Styled";
import {
  Box,
  HeadingStyled,
  LabelStyled,
} from "../../../components/styled/Elements";
import { Col, Row } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useTranslation } from "react-i18next";
import { SelectionDropdown } from "../../../components/styled/FormElements";
import { SpecializationList } from "../../../helpers/dummyConstants";
import ImageUpload from "../../../components/common/uploadFiles/imagesUpload";
import DatePickerDefault from "../../../components/common/inputFields/DatePicker";
import { useForm } from "react-hook-form";
import DocumentUpload from "../../../components/common/uploadFiles/documentUpload";
import { Calendar } from "../../../components/styled/AllImages";
import ValidationController from "../../../components/common/inputFields/ValidationController";
import { specializationDropdownList } from "../../../helpers/webConstants";

export const Step2 = ({
  register,
  control,
  errors,
  selectedFile,
  setSelectedFile,
}) => {
  const { t } = useTranslation();
  // Helper function to translate options
  const translateOptions = (options, t) =>
    options.map((option) => ({
      label: t(option.label), // Translate the label
      value: option.value,
    }));
  return (
    <>
      <StepsWrapper>
        <HeadingStyled className="stepsMainTitle" size="24px">
          {t("FALInformation")}
        </HeadingStyled>
        <Box className="stepFormContainer">
          <Row className="mt-3">
            <Col md={6}>
              {/* <ValidatedInput
                name="specialization"
                type="input"
                fieldType="text"
                placeholder="Specialization"
                label="Specialization"
                className=""
                staric="staric"
                register={register}
                errors={errors}
                validationRules={{
                  required: true,
                }}
              /> */}

              <Box className="formEleContainer">
                <LabelStyled className="labelForm">
                  {t("Specialization")}
                  <span className="staric">*</span>
                </LabelStyled>
                <ValidationController
                  name={"specialization"}
                  control={control}
                  errors={errors}
                  validationConfig={{
                    required: `fieldRequired`,
                  }}
                  renderer={({ field }) => (
                    <SelectionDropdown
                      name={field.name}
                      placeholder={t("Specialization")}
                      options={specializationDropdownList}
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  )}
                />
              </Box>
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="mothoq_number"
                type="input"
                fieldType="text"
                placeholder="EnterMothoqNo"
                label="MothoqNo"
                className=""
                // staric="staric"
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                }}
                // onChange={(e) => {
                // 	e.target.value = e.target.value.replace(/\D/g, "");
                // }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="fal_number"
                type="input"
                fieldType="text"
                placeholder="EnterFAL"
                label="FalNo"
                className=""
                staric="staric"
                register={register}
                errors={errors}
                validationRules={{
                  required: true,
                }}
                // onChange={(e) => {
                // 	e.target.value = e.target.value.replace(/\D/g, "");
                // }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="fal_id"
                type="input"
                fieldType="text"
                placeholder="EnteryourID"
                label="id"
                className=""
                staric="staric"
                register={register}
                errors={errors}
                validationRules={{
                  required: true,
                }}
                // onChange={(e) => {
                // 	e.target.value = e.target.value.replace(/\D/g, "");
                // }}
              />
            </Col>
            <Col md={12}>
              <Box className="formEleContainer">
                <LabelStyled className="labelForm">
                  {t("FALExpDate")}
                  <span className="staric">*</span>
                </LabelStyled>
                <DatePickerDefault
                  control={control}
                  minDate={new Date()}
                  rules={{
                    required: `fieldRequired`,
                  }}
                  name={"fal_exp_date"}
                  type={"input"}
                  placeholder={t("FALExpDate")}
                  icon={Calendar}
                />
              </Box>
            </Col>
            <Col md={12}>
              <Box className="formEleContainer">
                <LabelStyled className="labelForm">
                  {t("UploadFALLicense")}
                  <span className="staric">*</span>
                </LabelStyled>
                <ValidationController
                  name={"fal_license"}
                  control={control}
                  errors={errors}
                  validationConfig={{
                    required: `fieldRequired`,
                  }}
                  renderer={({ field }) => (
                    <DocumentUpload
                      UploadImage="UploadFALLicense"
                      UploadSecTxt="ordraganddrop"
                      accept=".pdf"
                      onChange={field.onChange}
                      selectedFile={selectedFile}
                      setSelectedFile={setSelectedFile}
                    />
                  )}
                />
              </Box>
            </Col>
          </Row>
        </Box>
      </StepsWrapper>
    </>
  );
};
